export default __webpack_public_path__ + "static/media/moreIcon.2f55bca0.svg";